import { useEffect } from 'react';

import { AppFeature, useIsFeatureEnabled } from 'src/config';

import { useMarginAccounts } from './useMarginAccounts';
import { useSwyftxMarginStore } from '../../state';

const useInitMarginAccount = () => {
  const { setTraderAccountId, traderAccountId } = useSwyftxMarginStore();
  const { data } = useMarginAccounts();
  const { isFeatureEnabled } = useIsFeatureEnabled();

  useEffect(() => {
    if (!isFeatureEnabled(AppFeature.SwyftxDerivatives) || traderAccountId) return;

    if (data?.accounts.length) {
      setTraderAccountId(data?.accounts[0].traderAccountId);
    }
  }, [data?.accounts, isFeatureEnabled, setTraderAccountId, traderAccountId]);
};

export { useInitMarginAccount };
